export default {
    AD_TOKEN:"Token",
    AD_MENU:"ad_menu",
    AD_USER:"ad_user"
}